import { useEffect, useState } from 'react';
import { DATA_ADAPTER } from '../config/adapters';
import { getServerNow, syncServerClock } from '../services/time/serverClock';

const TICK_MS = 1_000;
const RESYNC_MS = 5 * 60_000;

export function useServerClock() {
  const [now, setNow] = useState(() => getServerNow());

  useEffect(() => {
    let cancelled = false;

    const applyTick = () => {
      if (!cancelled) setNow(getServerNow());
    };

    const runSync = async () => {
      if (DATA_ADAPTER !== 'firebase') return;
      await syncServerClock();
      if (!cancelled) applyTick();
    };

    runSync().catch(() => {});

    const tickId = setInterval(applyTick, TICK_MS);
    const resyncId = setInterval(() => {
      runSync().catch(() => {});
    }, RESYNC_MS);

    return () => {
      cancelled = true;
      clearInterval(tickId);
      clearInterval(resyncId);
    };
  }, []);

  return { now };
}
